import React, { useContext } from 'react';
import './RenewalsPageInfo.scss';
import ReasonsToExtend from './ReasonsToExtend';
import JustSoYouKnow from './JustSoYouKnow';
import { Journey, PageAbsolutePath } from '../../../consts/Common';
import { SiteContext } from '../../../context/SiteContext';
import { DocumentView } from '../../common/Constants';
import { DocumentTreeItem, JourneyState } from '../../common/CommonTypes';
import UsefulDocuments from '../UsefulDocuments';

export type RenewalsPageInfoProps = {
  renewalsJourney: JourneyState;
  currentPath: string;
  setExpandedDocIds: (docIds: string[]) => void;
};

const RenewalsPageInfo = ({
  renewalsJourney,
  currentPath,
  setExpandedDocIds
}: RenewalsPageInfoProps): JSX.Element => {
  const { site } = useContext(SiteContext);
  const cms = site.content;
  const isCallCentre = site.journeyType === Journey.CallCentre;
  let justSoYouKnowText = '';
  let documents: DocumentTreeItem[] = renewalsJourney.documents;
  let showReasonsToExtend = false;

  if (currentPath === PageAbsolutePath.Renewals.Confirmation) {
    return (
      <div className='desktop-content-full'>
        <img
          className='landing-image'
          src={cms.confirmationPage.backgroundImageUrl}
          alt='confirmation page image'
        />
      </div>
    );
  }

  switch (currentPath) {
    case PageAbsolutePath.Renewals.PersonalDetails:
      justSoYouKnowText = cms.customerPage.justSoYouKnow;
      documents = isCallCentre ? renewalsJourney.documents : [];
      showReasonsToExtend = true;
      break;
    case PageAbsolutePath.Renewals.VehicleDetails:
      justSoYouKnowText = cms.vehiclePage.justSoYouKnow;
      showReasonsToExtend = true;
      break;
    case PageAbsolutePath.Renewals.Quote:
      justSoYouKnowText = cms.quotePage.justSoYouKnow;
      showReasonsToExtend = true;
      break;
    case PageAbsolutePath.Renewals.Summary:
      justSoYouKnowText = cms.summaryPage.justSoYouKnow;
      showReasonsToExtend = true;
      break;
    case PageAbsolutePath.Renewals.DirectDebit:
      justSoYouKnowText = cms.directDebitPage.justSoYouKnow;
      showReasonsToExtend = true;
      break;
    case PageAbsolutePath.Renewals.SinglePayment:
      justSoYouKnowText = cms.singlePaymentPage.justSoYouKnow;
      showReasonsToExtend = true;
      break;
    default:
  }

  if (isCallCentre) {
    showReasonsToExtend = false;
  }

  return (
    <div className='desktop-content page-info-container sticky-content'>
      {showReasonsToExtend && (
        <ReasonsToExtend reasonsToExtend={cms.reasonsToExtend} />
      )}
      {justSoYouKnowText !== '' && <JustSoYouKnow text={justSoYouKnowText} />}
      <UsefulDocuments
        documents={documents}
        cmsDocuments={isCallCentre ? [] : cms.usefulDocuments}
        view={DocumentView.Desktop}
        expandedDocIds={renewalsJourney.expandedDocIds}
        setExpandedDocIds={setExpandedDocIds}
        showDivider={false}
      />
    </div>
  );
};

export default RenewalsPageInfo;
